import React from "react"
import * as React_ from "elm-ts/lib/React"
import { pipe } from "fp-ts/function"
import { Variant } from "@flypengine/myFlyp-lib"
import * as Login from "./Login"
import * as Dashboard from "./Dashboard"
import * as M from "./Model"
import PageNotFound from "./components/PageNotFound"

export const view = (model: M.Model): React_.Html<M.Msg> => {
  return dispatch =>
    pipe(
      model,
      Variant.caseOf({
        [M._App]: app =>
          pipe(
            app.contents,
            Variant.caseOfWithDefault(<>{notFound()(dispatch)}</>)({
              [M.Page.Dashboard.name]: (dashboardModel: Dashboard.Model) =>
                Dashboard.view<M.Msg>(
                  M.configDashboard({
                    nextLocation: app.location,
                    user: app.user,
                  })
                )(dashboardModel)(dispatch),
            })
          ),
        [M._Auth]: auth =>
          Login.view<M.Msg>(M.configLogin)(auth.login)(dispatch),
      })
    )
}

function notFound(): React_.Html<M.Msg> {
  return dispatch => (
    <PageNotFound onClick={() => dispatch(M.Msg.resetNavigationMsg())} />
  )
}
